export const POST = "post";
export const STORY = "story";
export const REEL = "reel";
export const VIDEO = "video";
export const SHORT = "short";
